<ideal-product-vendor-link
  vendor-link
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Title; id: 'vendor-link'; priority: -1"
/>
<ideal-product-id-label product-id [productId]="id()" *renderInProductDetailsView="LayoutTargets.Title; id: 'product-id'; priority: -1" />
<ideal-product-short-description
  description
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Title; id: 'short-description'; priority: -1"
/>

<ideal-item-results [productId]="id()" *renderInProductDetailsView="LayoutTargets.Actions; id: 'items'" [idFilter]="nonCustomIdsFilter" />
@if (canOrderCustomLengths()) {
  <ideal-item-results
    custom-items
    [productId]="id()"
    [idFilter]="customIdsFilter"
    *renderInProductDetailsView="LayoutTargets.Actions; id: 'custom-items'"
  />
}
